<template>
  <vx-card>
    <div id="page-user-list">
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
        
          <h3>
            Add Contacts To New Selected Accounts -
            {{ campaignDescription.campaign_name }}
          </h3>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button @click="finish">Finish</vs-button>
        </vs-col>
      </vs-row>
      <div>
        <!-- AgGrid Table -->
        <DataGrid context='individaullySelectedGrid' 
          @addContactsPopUp="addContactsPopUp"
          @showContactsPopUp="showContactsPopUp"
          ref="individaullySelectedGrid"
          :columnDefs="accountColumnDefs"
          :rowData="accounts"
          :rowSelection="'single'"
          :dataSource="dataSource"
          @associateContactToSelectedAccountPopup="
            associateContactToSelectedAccountPopup
          "
        >
        </DataGrid>


        <vs-popup
          fullscreen
          class="holamundo"
          title="Select contacts to associate with selected account"
          :active.sync="associateContactToSelectedAccountPopupActive"
        >
          <div class="text-center">
            <h5>Account : {{ selected_account.company_name }}</h5>
          </div>

          <div></div>
          <NewDataGrid :context="'AssociateContactToSelectedAccount'"
            @showCampaignStatusPopup="showCampaignStatusPopup"
            @refreshAccountSelectionGrid="refreshAccountSelectionGrid"
            @showContactsPopUp="showContactsPopUp"
            @associateContactToSelectedAccountPopup="
              associateContactToSelectedAccountPopup
            "
            :selected_account="selected_account"
            ref="associateContactToSelectedAccount"
            :columnDefs="contactsColumnDefs"
            :rowData="contacts"
            :dataSource="AssociatedAccountContactsDataSource"
          >
          </NewDataGrid>
        </vs-popup>

        <vs-popup
          style="z-index: 999999;"
          class="holamundo"
          title="Campaign Details"
          :active.sync="showCampaignDetailsPopUp"
        >
          <div class="text-center" v-if="selected_contact_details">
            <h5>
              Contact : {{ selected_contact_details.forename }}
              {{ selected_contact_details.surname }}
            </h5>
          </div>
          <template v-if="campaign_statuses.includes('Live')">
            <h6>Active Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Live'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <template v-if="campaign_statuses.includes('Paused')">
            <h6>Paused Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Paused'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <template v-if="campaign_statuses.includes('Completed')">
            <h6>Historic Campaigns</h6>
            <vs-table
              class="mb-10"
              stripe
              v-if="selected_contact_details_campaigns"
              :data="selected_contact_details_campaigns"
            >
              <template slot="thead">
                <vs-th sort-key="campaign_code">Campaign Code</vs-th>
                <vs-th sort-key="campaign_name">Campaign Name</vs-th>
                <vs-th sort-key="campaign_status">Campaign Status</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <template v-if="data[indextr].campaign_status == 'Completed'">
                    <vs-td :data="data[indextr].campaign_code">
                      {{ data[indextr].campaign_code }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_name">
                      {{ data[indextr].campaign_name }}
                    </vs-td>
                    <vs-td :data="data[indextr].campaign_status">
                      {{ data[indextr].campaign_status }}
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </template>

          <div></div>
        </vs-popup>
        <vs-popup
          fullscreen
          style="z-index: 999999;"
          class="holamundo"
          :title="'Add New Contact to ' + selectedAccountForContact"
          :active.sync="addNewContactsPopUp"
        >


          <vs-row vs-w="12" class="mb-5 mt-10">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Title :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="title"
                    v-model="contactsDescription.title"
                    v-validate="'required'"
                    data-vv-as="Title"
                  />
                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('title')"
                    >{{ errors.first("title") }}</span
                  >
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Forename :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="forename"
                    v-model="contactsDescription.forename"
                    v-validate="'required'"
                    data-vv-as="Forename"
                  />
                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('forename')"
                    >{{ errors.first("forename") }}</span
                  >
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Surname :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="surname"
                    v-model="contactsDescription.surname"
                    v-validate="'required'"
                    data-vv-as="Surname"
                  />
                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('surname')"
                    >{{ errors.first("surname") }}</span
                  >
                </div>
              </div>
            </vs-col>
             <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>DDI :</span>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <v-select name="ddi_phone_code" class="ddi_phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="contactsDescription.ddi_phone_code" />
                  
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-input @input="contactsDescription.ddi = contactsDescription.ddi.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                    class="w-full"
                    name="ddi"
                    v-model="contactsDescription.ddi"
                    data-vv-as="ddi"
                  />
                  
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button color="primary" @click="addDDI" type="filled"
                    >Add</vs-button
                  >
                </div>
              </div>
              <template v-if="contactsDescription.ddis.length > 0">
                <h6 class="mb-2">Added ddi Number</h6>
              </template>

              <template v-for="(ddi, index) in contactsDescription.ddis">
                <span :key="index" class="p-5">
                  <p>
                    <vs-radio
                      v-model="contactsDescription.primary_ddi"
                      :vs-value="ddi"
                      class="mr-4"
                      vs-name="primary_ddi"
                    ></vs-radio
                    >{{ ddi.ddi_phone_code }} - {{ ddi.ddi }}

                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedddi(ddi)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Job Title :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="job_title"
                    v-model="contactsDescription.job_title"
                    v-validate="'required'"
                    data-vv-as="Job Title"
                  />
                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('job_title')"
                    >{{ errors.first("job_title") }}</span
                  >
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Email :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="email"
                    v-model="contactsDescription.email"
                    v-validate="'email'"
                    data-vv-as="Email"
                  />
                  <div class = "text-center pt-5">{{ email_validate_status ? 'Status : ' + email_validate_status : null}}</div>

                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('email')"
                    >{{ errors.first("email") }}</span
                  >
                </div>

                <div class="vx-col sm:w-1/3 w-full">
                  <vs-icon
              style="cursor:pointer;"
                  @click="validateEmailZeroBounce"
                  color="success"
                  icon="checkmark"
                ></vs-icon>
                  <vs-button color="primary" @click="addEmail" type="filled"
                    >Add</vs-button
                  >
                </div>
              </div>
              <template v-if="contactsDescription.emails.length > 0">
                <h6 class="mb-2">Added Emails</h6>
              </template>

              <template v-for="(email, index) in contactsDescription.emails">
                <span :key="index" class="p-5">
                  <p>
                    <vs-radio
                      v-model="contactsDescription.primary_email"
                      :vs-value="email"
                      class="mr-4"
                      vs-name="primary_email"
                    ></vs-radio
                    >{{ email }}
                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedEmail(email)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </vs-col>
          </vs-row>
        
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Mobile :</span>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <v-select name="mobile_phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="contactsDescription.mobile_phone_code" />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <vs-input @input="contactsDescription.mobile = contactsDescription.mobile.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                    class="w-full"
                    name="mobile"
                    v-model="contactsDescription.mobile"
                    data-vv-as="Mobile"
                  />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button color="primary" @click="addMobile" type="filled"
                    >Add</vs-button
                  >
                </div>
              </div>
              <template v-if="contactsDescription.mobiles.length > 0">
                <h6 class="mb-2">Added Mobile Number</h6>
              </template>

              <template v-for="(mobile, index) in contactsDescription.mobiles">
                <span :key="index" class="p-5">
                  <p>
                    <vs-radio
                      v-model="contactsDescription.primary_mobile"
                      :vs-value="mobile"
                      class="mr-4"
                      vs-name="primary_mobile"
                    ></vs-radio
                    >{{ mobile.mobile_phone_code }}{{ mobile.mobile }}

                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedMobile(mobile)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Seniority :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    label="seniority"
                    name="seniority"
                    :options="contactsDescription.seniorities"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="contactsDescription.seniority"
                  />
               
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Social Media :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    name="social_media"
                    v-model="contactsDescription.social_media"
                    v-validate="'url:require_protocol'"
                    data-vv-as="Social Media"
                  />
                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('social_media')"
                    >{{ errors.first("social_media") }}</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button
                    color="primary"
                    @click="addSocialMedia"
                    type="filled"
                    >Add</vs-button
                  >
                </div>
              </div>
              <template v-if="contactsDescription.social_medias.length > 0">
                <h6 class="mb-2">Added Social Media</h6>
              </template>

              <template
                v-for="(social_media,
                index) in contactsDescription.social_medias"
              >
                <span :key="index" class="p-5">
                  <p>
                    <vs-radio
                      v-model="contactsDescription.primary_social_media"
                      :vs-value="social_media"
                      class="mr-4"
                      vs-name="primary_social_media"
                    ></vs-radio
                    >{{ social_media }}

                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedSocialMedia(social_media)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Role :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    name="role"
                    label="role"
                    :options="contactsDescription.roles"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="contactsDescription.role"
                    data-vv-as="Role"
                  />
                  
                </div>
               
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Sub Role :</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    name="sub_role"
                    label="sub_role"
                    :options="contactsDescription.sub_roles"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="contactsDescription.sub_role"
                    data-vv-as="Sub Role"
                  />

                </div>
               
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12"> </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="text-center">
                <vs-button
                  class="mr-5"
                  color="danger"
                  type="border"
                  @click="addContactsAndAddSubmitForm"
                  >Submit And Add
                </vs-button>
                <vs-button
                  color="danger"
                  @click="addContactsSubmitForm"
                  type="border"
                  >Submit</vs-button
                >
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>
      </div>
    </div>
  </vx-card>
</template>

<script>
var revanueValueFormatter = function(params) {
  if(params.data.revenue){

    if(params.data.currency_name != undefined){
      return params.data.currency_name + " " + params.data.revenue;
    }
  }
  // return '$' + params.value
};
var DatefilterParams = {
  comparator: function(filterLocalDateAtMidnight, cellValue) {
    // In the example application, dates are stored as dd/mm/yyyy
    // We create a Date object for comparison against the filter date
    var dateParts = cellValue.split("/");
    var day = Number(dateParts[2]);
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[0]);
    var cellDate = new Date(day, month, year);

    // Now that both parameters are Date objects, we can compare
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  },
  browserDatePicker: true,
  minValidYear: 2000
};

var campaignStatus = function campaignStatus(params) {
  let active_status = "";
  let historic_status = "";
  let member_status = "";
  let paused_status = "";

  let contacts_clients = params.data.campaign_client_id;
  let campaign_clients = window.campaignDescriptionWithClients.campaign_clients;


  console.log(campaign_clients)

  const found = campaign_clients.some(r => contacts_clients.indexOf(r) >= 0);
  if (found) {
    const arrayOfStrings = params.data.campaign_status;

    if (window.live_campaign_status == true) {
      const active_str = "Live";
      const active_found = arrayOfStrings.find(v => active_str === v);
      if (active_found) {
        active_status =
          '<span><i class="material-icons">text_format</i></span>';
      }
    }

    if (window.completed_campaign_status == true) {
      const historic_str = "Completed";
      const historic_found = arrayOfStrings.find(v => historic_str === v);
      if (historic_found) {
        historic_status =
          '<span><i class="material-icons">check_circle_outline</i></span>';
      }
    }

    if (window.paused_campaign_status == true) {
      const paused_str = "Paused";
      const paused_found = arrayOfStrings.find(v => paused_str === v);
      if (paused_found) {
        paused_status =
          '<span><i class="material-icons">pause_circle_outline</i></span>';
      }
    }

    if (window.member_campaign_status == true) {
      const arrayOfIds = params.data.campaign_ids;
      const campaignId = window.location.pathname.split("/").pop();
      const member_found = arrayOfIds.find(v => campaignId === v);
      if (member_found) {
        member_status =
          '<span><i class="material-icons">perm_identity</i></span>';
      }
    }

    return (
      active_status +
      " " +
      historic_status +
      " " +
      member_status +
      " " +
      paused_status
    );
  }
};

import DataGrid from "@/components/aggrid/EnrichAggrid.vue";
import NewDataGrid from "@/components/aggrid/EnrichContactAggrid.vue";
import vSelect from "vue-select";
import { CampaignStatusFilter } from "@/components/aggrid/CampaignStatusFilter.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
export default {
  components: {
    DataGrid,
    NewDataGrid,
    CampaignStatusFilter: CampaignStatusFilter,
    "v-select": vSelect
  },
  name: "EnrichAccountsContactsIndividually",
  data() {
    return {
      enrich_master_account_website_field_columns: '',
      enrich_master_account_linkedin_field_columns: '',
      enrich_master_account_sic_code_field_columns: '',
      enrich_master_account_phone_field_columns: '',
      enrich_master_account_switchboard_field_columns : '',
    
      enrich_master_account_core_field_columns: '',
      enrich_master_account_none_core_field_columns: '',
    enrich_master_account_none_core_field_ids: '',
    enrich_master_contact_none_core_field_columns: '',
    enrich_master_contact_none_core_field_ids: '',
    enrich_none_core_number_type_ids : [],
    enrich_master_account_none_core_field_ids: '',
    campaign_contact_none_core_field_columns: '',
    campaign_contact_none_core_field_ids: '',
      user_id : null,
        user_role : null,
      email_validate_status: null,
      all_phone_codes:[],
      selectedAccountForContact : null,
      contactsDescription: {
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,
        primary_email: null,
        social_medias: [],
        mobiles: [],
                ddis: [],
        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
                ddi: null,
        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: []
      },
      associateContactToSelectedAccountPopupActive: false,
      addNewContactsPopUp: false,
      campaign_statuses: [],
      selected_contact_details: null,
      selected_contact_details_campaigns: null,
      contacts: [],
      contactsDataSource: {},
      associateContactToAccountPopupActive: false,
      showCampaignDetailsPopUp: false,
      dataSource: {},
      campaignDescription: [],
      accounts: [],
      selected_account: {},
      contactsColumnDefs: [
       
      ],
      accountColumnDefs: [
        ],
    };
  },
  watch: {
    showCampaignDetailsPopUp: function(value) {
      if (value) {
        if (window.live_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Live";
          });
        }

        if (window.completed_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Completed";
          });
        }

        if (window.paused_campaign_status == false) {
          this.campaign_statuses = this.campaign_statuses.filter(function(
            item
          ) {
            return item !== "Paused";
          });
        }
      }
    },
    "contactsDescription.role"(val) {
      if (val) {
        this.contactsDescription.sub_roles = [];
        this.getSubRole(val.id);
      }
    },
    "contactsDescription.mobile_phone_code"(val) {
        alert("sdfsdfsdf")
    }
  },
  computed: {},
  methods: {
    getSelectedCampaignFieldForEnrich() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAlreadySelectedAccountCampaignField",
          this.$route.params.campaignId
        )
        .then(response => {
          let result = response.data
          let selected_account_columns = JSON.parse(result['account_fields']);



             selected_account_columns = selected_account_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' && ele.identifier != 'currency_code' 
              });


              var index = 1;
            selected_account_columns.forEach(function(ele) {

              ele.id = ele.uuid

          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                let ele_with_t = 'acc' + index + '.' + ele.field;

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }



                self.enrich_master_account_none_core_field_columns = self.enrich_master_account_none_core_field_columns + ',' + ele.id;

                self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + ',' + ele_with_t;


                  // if (ele.type == 'number'){
                  //   self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + '::bigint,' + ele_with_t;
                  // }else{
                  //   self.enrich_master_account_none_core_field_ids = self.enrich_master_account_none_core_field_ids + ',' + ele_with_t;
                  // }

                
                index += 1;

                }else{
                  ele.field = ele.identifier;
                  let account_identifier = null

                  if (ele.identifier == 'linkedin'){
                    account_identifier = " string_agg(distinct l.url, ',') as linkedin ";
                    self.enrich_master_account_linkedin_field_columns = self.enrich_master_account_linkedin_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'sic_code'){
                    // account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct scl.code  , ' , ')) , ' , ')) , ' , ') from account_sic_codes a_s_c left join sic_code_lists scl on scl.uuid == a_s_c.sic_code_id where a_s_c.account_id = a.uuid limit 1 ) as sic_code ";
                    // self.enrich_master_account_sic_code_field_columns = self.enrich_master_account_sic_code_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'website'){
                    account_identifier = " string_agg(distinct w.url, ',') as website ";
                    self.enrich_master_account_website_field_columns = self.enrich_master_account_website_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'phone'){
                    account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as phone ";
                    self.enrich_master_account_phone_field_columns = self.enrich_master_account_phone_field_columns + ',' + account_identifier
                  }
                  else if (ele.identifier == 'switchboard'){
                    account_identifier = " (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as switchboard ";
                    self.enrich_master_account_switchboard_field_columns = self.enrich_master_account_switchboard_field_columns + ',' + account_identifier
                  }
                  else {
                  
                  account_identifier = 'a.' + ele.identifier;
                  self.enrich_master_account_core_field_columns = self.enrich_master_account_core_field_columns + ',' + account_identifier
                }
                 
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_account_columns

          localStorage.setItem("enrich_master_account_none_core_field_columns", self.enrich_master_account_none_core_field_columns);
          localStorage.setItem("enrich_master_account_none_core_field_ids", self.enrich_master_account_none_core_field_ids);

          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);

          

          localStorage.setItem("enrich_master_account_core_field_columns", self.enrich_master_account_core_field_columns);

          localStorage.setItem("enrich_master_account_website_field_columns", self.enrich_master_account_website_field_columns);
          localStorage.setItem("enrich_master_account_linkedin_field_columns", self.enrich_master_account_linkedin_field_columns);

          localStorage.setItem("enrich_master_account_phone_field_columns", self.enrich_master_account_phone_field_columns);

          localStorage.setItem("enrich_master_account_switchboard_field_columns", self.enrich_master_account_switchboard_field_columns);

          


          self.accountColumnDefs.push(   {
          headerName: "Actions",
          field: "transactions",
          cellRenderer: "CellRendererActions",
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 90
        }
            );




        




      


















        })
        .catch(err => {
          console.log("ERR" , err);
        });
    },
    getAllContactSelectedCampaignColumns() {
    var self = this;
    self.$store
      .dispatch(
        "campaignsManagement/getAllContactSelectedCampaignColumns",
        self.$route.params.campaignId
      )
      .then(res => {
            let selected_columns = JSON.parse(res.data);


            selected_columns = selected_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
            });

            var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid

          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                let ele_with_t = 'con' + index + '.' + ele.field;

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }
                self.campaign_contact_none_core_field_columns = self.campaign_contact_none_core_field_columns + ',' + ele.id;
                self.campaign_contact_none_core_field_ids = self.campaign_contact_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.contactsColumnDefs = selected_columns

          self.contactsColumnDefs.push(   {
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
          headerName: "Actions",
          field: "transactions",
          pinned: true,
          checkboxSelection: true,
          width: 50,
          suppressHeaderMenuButton: true
        }
            );

          localStorage.setItem("campaign_contact_none_core_field_columns", self.campaign_contact_none_core_field_columns);
          localStorage.setItem("campaign_contact_none_core_field_ids", self.campaign_contact_none_core_field_ids);
          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);


      

      

      })
      .catch(err => {
        console.log(err);
      });
  },
    getAllAccountSelectedCampaignColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          self.$route.params.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid
          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }
                let ele_with_t = 'acc' + index + '.' + ele.field;

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }
                self.campaign_account_none_core_field_columns = self.campaign_account_none_core_field_columns + ',' + ele.id;
                self.campaign_account_none_core_field_ids = self.campaign_account_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns

          localStorage.setItem("campaign_account_none_core_field_columns", self.campaign_account_none_core_field_columns);
          localStorage.setItem("campaign_account_none_core_field_ids", self.campaign_account_none_core_field_ids);

          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);



            self.accountColumnDefs.push(   {
          headerName: "Actions",
          field: "transactions",
          cellRenderer: "CellRendererActions",
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 120
        }
            );

        

        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSocialMedia(social_media) {
      this.contactsDescription.social_medias = this.contactsDescription.social_medias.filter(
        item => {
          return item != social_media;
        }
      );
    },
    removeSelectedEmail(email) {
      this.contactsDescription.emails = this.contactsDescription.emails.filter(
        item => {
          return item != email;
        }
      );
    },
    removeSelectedMobile(mobile) {
      this.contactsDescription.mobiles = this.contactsDescription.mobiles.filter(
        item => {
          return item != mobile;
        }
      );
    },
    removeSelectedDDI(ddi) {
    this.contactsDescription.ddis = this.contactsDescription.ddis.filter(
      item => {
        return item != ddi;
      }
    );
  },
    showCampaignStatusPopup(value) {
      if (value.campaigns.length != 0) {
        this.selected_contact_details = value;
        const key = "uuid";
        this.selected_contact_details_campaigns = [
          ...new Map(
            this.selected_contact_details.campaigns.map(item => [
              item[key],
              item
            ])
          ).values()
        ];
        let self = this;
        self.selected_contact_details_campaigns.map(function(ele) {
          self.campaign_statuses.push(ele.campaign_status);
        });

        if(this.campaign_statuses.includes('Live') || this.campaign_statuses.includes('Paused') || this.campaign_statuses.includes('Completed')){
          self.showCampaignDetailsPopUp = true;
        }else{
           this.$vs.notify({
              color: "success",
              title: "Campaign Details",
              text: "This campaign status is either scheduled or with no details.Please check the campaign status."
            });
        }
      }
    },
    validateEmailZeroBounce(){
      let self = this

      if (this.contactsDescription.email){
        self.$vs.loading();

        this.$store
        .dispatch("contactsManagement/validateEmailZeroBounce", this.contactsDescription.email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close();

         console.log(res)
        })
        .catch(err => {
          console.error(err);
        });
      }


     

    },
    addEmail() {
      if (
        this.contactsDescription.email &&
        !this.contactsDescription.emails.includes(
          this.contactsDescription.email
        )
      )
        this.contactsDescription.emails.push(this.contactsDescription.email);
      this.contactsDescription.email = null;
      this.email_validate_status = null
    },
    addMobile() {
      if (
        this.contactsDescription.mobile && this.contactsDescription.mobile_phone_code &&
        !this.contactsDescription.mobiles.includes(
          this.contactsDescription.mobile
        )
      )
        this.contactsDescription.mobiles.push({mobile : this.contactsDescription.mobile , mobile_phone_code : this.contactsDescription.mobile_phone_code.phone_code});
      this.contactsDescription.mobile = null;
      this.contactsDescription.mobile_phone_code = null;

    },
    addDDI() {
    if (
      this.contactsDescription.ddi &&  this.contactsDescription.ddi_phone_code &&
      !this.contactsDescription.ddis.includes(
        this.contactsDescription.ddi
      )
    )
      this.contactsDescription.ddis.push({ ddi : this.contactsDescription.ddi , ddi_phone_code : this.contactsDescription.ddi_phone_code.phone_code });
    this.contactsDescription.ddi = null;
    this.contactsDescription.ddi_phone_code = null;

  },
    addSocialMedia() {
      if (
        this.contactsDescription.social_media &&
        !this.contactsDescription.social_medias.includes(
          this.contactsDescription.social_media
        )
      )
        this.contactsDescription.social_medias.push(
          this.contactsDescription.social_media
        );
      this.contactsDescription.social_media = null;
    },
    refreshAccountSelectionGrid() {
      this.$refs.individaullySelectedGrid.gridApi.refreshServerSide({purge : true});
      this.$refs.associateContactToAccount.gridApi.refreshServerSide({purge : true});
    },
    showContactsPopUp(value) {
      this.$refs.associateContactToAccount.gridApi.setFilterModel(null);
      // this.$refs.associateContactToAccount.gridApi.refreshServerSide({purge : true});
      this.selected_account = value;
      if (this.associateContactToAccountPopupActive == true) {
        this.associateContactToAccountPopupActive = false;
      } else {
        this.associateContactToAccountPopupActive = true;
      }
      this.$refs.associateContactToAccount.gridApi.refreshServerSide({purge : true});
      this.getContactDataSource();
    },
    associateContactToSelectedAccountPopup(value) {
      this.$refs.associateContactToSelectedAccount.gridApi.setFilterModel(null);
      // this.$refs.associateContactToAccount.gridApi.refreshServerSide({purge : true});

      this.selected_account = value;
      if (this.associateContactToSelectedAccountPopupActive == true) {
        this.associateContactToSelectedAccountPopupActive = false;
      } else {
        this.associateContactToSelectedAccountPopupActive = true;
      }

      this.$refs.associateContactToSelectedAccount.gridApi.refreshServerSide({purge : true});
      this.getAccountContactDataSource();
    },
    addContactsPopUp(value) {

      if (!value.company){
        value.company = value.company_name
      }

      this.selectedAccountForContact = value.company


      this.contactsDescription.title = '';
            this.contactsDescription.forename = '';
            this.contactsDescription.surname = '';
            this.contactsDescription.email = '';
            this.contactsDescription.job_title = '';
            this.contactsDescription.mobile = '';
            this.contactsDescription.role = '';
            this.contactsDescription.sub_role = '';
            this.contactsDescription.seniority = '';
            this.contactsDescription.mobiles = [];
            this.contactsDescription.ddi = '';
            this.contactsDescription.ddis = [];
            this.contactsDescription.ddi_phone_code = '';
            this.contactsDescription.mobile_phone_code = '';

            this.contactsDescription.social_media = '';
            this.contactsDescription.emails = [];
            this.contactsDescription.social_medias = [];



      this.selected_account = value;
      this.addNewContactsPopUp = true;
      this.$validator.reset();

      console.log(this.selected_account)


      // this.errors = []
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.enrich_master_account_none_core_field_columns = localStorage.getItem("enrich_master_account_none_core_field_columns");
          params.request.enrich_master_account_none_core_field_ids = localStorage.getItem("enrich_master_account_none_core_field_ids");
          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");
          params.request.enrich_master_account_website_field_columns = localStorage.getItem("enrich_master_account_website_field_columns");
          params.request.enrich_master_account_linkedin_field_columns = localStorage.getItem("enrich_master_account_linkedin_field_columns");
          params.request.new_selected_account_ids_to_campaign = localStorage.getItem("new_selected_account_ids_to_campaign");

          params.request.enrich_master_account_phone_field_columns = localStorage.getItem("enrich_master_account_phone_field_columns");
          params.request.enrich_master_account_switchboard_field_columns = localStorage.getItem("enrich_master_account_switchboard_field_columns");

        self.$store
            .dispatch("campaignsManagement/fetchCampaign", self.$route.params.campaignId)
            .then(res => {
              self.campaignDescription = res.data;

              console.log(self.campaignDescription);

              params.request.table_name = 'temp_' + self.campaignDescription["id"].replaceAll("-", "_") + "_accounts";

              console.log(params.request.table_name);



          self.$store
            .dispatch(
              "accountsManagement/fetchAllMatchedAccountsOfCampaign",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.individaullySelectedGrid.gridApi.hideOverlay();

                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.individaullySelectedGrid.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] });
              }









            })
            .catch(err => {
              console.error(err);
            });
                        }) .catch(err => {
              console.error(err);
            });

            
            
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);

    },
    finish: function() {
      this.$router
        .push("/accounts/matched/" + this.$route.params.campaignId + "/" + btoa(this.campaignDescription.campaign_name))
        .catch(() => {});
    },
    getSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.contactsDescription.seniorities = res.data;
          console.log(this.contactsDescription.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.contactsDescription.roles = res.data;
          console.log(this.contactsDescription.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSubRole(role_id) {
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.contactsDescription.sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaignWithClients", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
          window.campaignDescriptionWithClients = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    addContactsAndAddSubmitForm() {
      this.getCampaignDescription();
      this.getSeniority();
      this.getRoles();
      this.addContactsSubmitFormAgain();
    },
    addContactsSubmitForm() {
      this.getCampaignDescription();
      this.getSeniority();
      this.getRoles();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.contactsDescription.account = this.selected_account;
          this.contactsDescription.campaignId = this.$route.params.campaignId;
          this.addContactsToAddInCampaign();
        } else {
          // form have errors
        }
      });
    },
    addContactsSubmitFormAgain() {
      this.getCampaignDescription();
      this.getSeniority();
      this.getRoles();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.contactsDescription.account = this.selected_account;
          this.contactsDescription.campaignId = this.$route.params.campaignId;
          this.addContactsAgain();
        } else {
          // form have errors
        }
      });
    },
    addContactsToAddInCampaign() {
      this.contactsDescription.user_id = this.user_id
      this.$store
        .dispatch(
          "contactsManagement/addContactsToAddInCampaign",
          this.contactsDescription
        )
        .then(res => {
          if (res.data.status == "success") {
            this.addNewContactsPopUp = false;
            this.$vs.notify({
              color: "success",
              title: "Contact Added",
              text: "The contact was added successfully and added to campaign."
            });
            this.$refs.individaullySelectedGrid.gridApi.refreshServerSide({purge : true});
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    addContactsAgain() {
      this.$store
        .dispatch(
          "contactsManagement/addContactsToAddInCampaign",
          this.contactsDescription
        )
        .then(res => {
          if (res.data.status == "success") {
            this.addNewContactsPopUp = false;
            this.$vs.notify({
              color: "success",
              title: "Contact Added",
              text: "The contact was added successfully and added to campaign."
            });
            this.$refs.individaullySelectedGrid.gridApi.refreshServerSide({purge : true});


            this.addContactsPopUp(this.selected_account);

          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getContactDataSource() {
      var self = this;
      window.live_campaign_status = true;
      window.completed_campaign_status = true;
      window.member_campaign_status = true;
      window.paused_campaign_status = true;

      this.contactsDataSource = {
        getRows(params) {
          if (params.request.filterModel[0] !== undefined) {
            let filtered_campaign_status =
              params.request.filterModel[0].campaign_status;
            if (filtered_campaign_status.text_format) {
              window.live_campaign_status = true;
            } else {
              window.live_campaign_status = false;
            }

            if (filtered_campaign_status.check_circle_outline) {
              window.completed_campaign_status = true;
            } else {
              window.completed_campaign_status = false;
            }

            if (filtered_campaign_status.pause_circle_outline) {
              window.paused_campaign_status = true;
            } else {
              window.paused_campaign_status = false;
            }

            if (filtered_campaign_status.perm_identity) {
              window.member_campaign_status = true;
            } else {
              window.member_campaign_status = false;
            }
          }

          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);
          params.request.selected_accounts = self.selected_accounts;
          params.request.campaign_contact_none_core_field_columns = localStorage.getItem("campaign_contact_none_core_field_columns");
          params.request.campaign_contact_none_core_field_ids = localStorage.getItem("campaign_contact_none_core_field_ids");
          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");
          self.$store
            .dispatch(
              "accountsManagement/fetchAllMatchedContactOfCampaign",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.associateContactToAccount.gridApi.hideOverlay();

                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.associateContactToAccount.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] });
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getAccountContactDataSource() {
      var self = this;
      window.live_campaign_status = true;
      window.completed_campaign_status = true;
      window.member_campaign_status = true;
      window.paused_campaign_status = true;

      this.AssociatedAccountContactsDataSource = {
        getRows(params) {
          if (params.request.filterModel[0] !== undefined) {
            let filtered_campaign_status =
              params.request.filterModel[0].campaign_status;
            if (filtered_campaign_status.text_format) {
              window.live_campaign_status = true;
            } else {
              window.live_campaign_status = false;
            }

            if (filtered_campaign_status.check_circle_outline) {
              window.completed_campaign_status = true;
            } else {
              window.completed_campaign_status = false;
            }

            if (filtered_campaign_status.pause_circle_outline) {
              window.paused_campaign_status = true;
            } else {
              window.paused_campaign_status = false;
            }

            if (filtered_campaign_status.perm_identity) {
              window.member_campaign_status = true;
            } else {
              window.member_campaign_status = false;
            }
          }

          // params.request.campaignId = self.$route.params.campaignId;
          // params.request.accountId = self.selected_account.uuid;


          params.request.campaignId = self.$route.params.campaignId;
          params.request.selected_accounts = [self.selected_account.uuid];
          params.request.campaign_contact_none_core_field_columns = localStorage.getItem("campaign_contact_none_core_field_columns");
          params.request.campaign_contact_none_core_field_ids = localStorage.getItem("campaign_contact_none_core_field_ids");
          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");


          self.$store
            .dispatch(
              "accountsManagement/fetchAllMatchedAccountAssociatedMasterContacts",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.associateContactToSelectedAccount.gridApi.hideOverlay();

                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.associateContactToSelectedAccount.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] });
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    }
  },
  destroyed() {
    // localStorage.removeItem('enrich_advanced_data_reloaded')
    // localStorage.removeItem('enrich_master_account_website_field_columns')
    // localStorage.removeItem('enrich_master_account_linkedin_field_columns')
    // localStorage.removeItem('enrich_master_account_sic_code_field_columns')
    // localStorage.removeItem('enrich_master_account_phone_field_columns')
    // localStorage.removeItem('enrich_master_account_switchboard_field_columns')
    // localStorage.removeItem('enrich_master_account_core_field_columns')
    // localStorage.removeItem('enrich_master_account_none_core_field_columns')
    // localStorage.removeItem('enrich_master_account_none_core_field_ids')
    // localStorage.removeItem('enrich_none_core_number_type_ids')

    
    // localStorage.removeItem('enrich_master_contact_none_core_field_columns')
    // localStorage.removeItem('enrich_master_contact_none_core_field_ids')


  },
  beforeMount() {
    this.getDataSource();
    this.getContactDataSource();
    this.getAccountContactDataSource();
  },
  mounted() {
    this.getCampaignDescription();
    this.getSelectedCampaignFieldForEnrich()

    // this.getAllAccountSelectedCampaignColumns();
    this.getAllContactSelectedCampaignColumns();
    this.getSeniority();
    this.getRoles();
    this.getAllPhoneCodes()

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.user_id = userInfo["uid"];
      this.user_role = userInfo["userRole"];
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }

    this.campaignId = this.$route.params.campaignId;
  }
};
</script>

<style lang="scss">


.example-header {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 16px;
  margin-bottom: 15px;
}

.example-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#page-size {
  padding: 5px 10px;
}
</style>
